export default [
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/menu/user/user.vue'),
    meta: {
      pageTitle: 'کاربران',
      action: 'show',
      resource: 'UserManager',
    },
  },
  {
    path: '/userrole',
    name: 'userrole',
    component: () => import('@/views/menu/user/userrole.vue'),
    meta: {
      pageTitle: 'مدیریت نقش ها',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details/:id?',
    name: 'userroledetails',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'جزئیات نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
]
